/* eslint-disable no-unused-vars */
export enum API_URL {
    // auth
    GET_TON_WALLET = "/airdrop/tonWallet",
    POST_ADD_WALLET = "/airdrop/add-wallets",
    GET_WHITE_LIST = "/airdrop/isWhiteList",
}

